import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

export default function NotFoundMessage() {
  const { t } = useTranslation();

  return (
    <div className="empty error">
      <strong>{t('error_not_found_title')}</strong>
      <p>
        <Trans i18nKey="error_not_found_description" />
      </p>
    </div>
  );
}
